import { Divider } from "antd";
import "./SiteSettings.css";
import PrimaryButton from "components/Buttons/PrimaryButton/PrimaryButton";
import { Form, Upload } from "antd";
import Selector from "components/Selector/Selector";
import TextInput from "components/Inputs/TextInput/TextInput";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import centralApi from "services/centralApi";
import Spinner from "components/Spinner/Spinner";
import { getFeaturesSettings } from "redux/features/app/featuresSettingSlice"; //calling features setting from redux
import useMessage from "hooks/useMessage";
import { t } from "i18next";
import { API_ENDPOINTS } from "utils/constants";
import {IAuthType,AuthStatus} from "utils/constants/index"
import { DataTypeEnum,  BooleanStringEnum } from "utils/enums";
import { getToken } from "redux/features/app/authTokenSlice";
import { setSiteSetting } from "redux/features/app/siteSettingSlice";
import { validateImageDimensions } from "helperFunctions/file";
const SiteSettings: React.FC = () => {
  const dispatch: any = useDispatch();
  const [form] = Form.useForm();
  const { showError, showSuccess } = useMessage();
  const features = useSelector((state: any) => state.featuresSetting.data);
  const featuresSetting = features[0]?.siteSettings;
  const loginUser = useSelector((state: any) => state.loginUser);
  const activeApp = useSelector((state: any) => state.activeApp);
  
  const [formData, setFormData] = useState<any>();
  useEffect(() => {
    setFormData(featuresSetting);
 
  }, [featuresSetting]);

  const appId = activeApp.appId;
  const api_key = loginUser.data.api_key;
  const onFormSubmit = () => {
     
    const updatedFormData = {
      is_sso: formData.is_sso,
      portal_name: formData.portal_name || undefined,
      sso_type: formData.sso_type,
      samlConfig: formData.samlConfig,
      ldapConfig: formData.ldapConfig,
      customJwtConfig:formData.customJwtConfig,
      logo_image_url: formData?.logo_image_url || undefined,
      logo_image_name: formData?.logo_image_name || undefined,
      captcha: formData?.captcha,
      useEmailChannel: formData?.useEmailChannel || BooleanStringEnum.FALSE,
      otpExpiry:Number(formData?.otpExpiry),
      loginTimeExpiry:Number(formData?.loginTimeExpiry),
      allowResetPassword:formData?.allowResetPassword,
      companyName:formData?.companyName,
      privacyPolicyLink:formData?.privacyPolicyLink,
      passwordMaxAge:formData?.passwordMaxAge,
      passwordRetryLimit:Number(formData?.passwordRetryLimit)




    };
    if (formData.sso_type === IAuthType.SAML) {
      updatedFormData.ldapConfig = {};
    } else if (formData.sso_type === IAuthType.AD) {
      updatedFormData.samlConfig = {};
    } 
    else if (formData.sso_type === IAuthType.CUSTOMJWT) {
      updatedFormData.ldapConfig = {};
      updatedFormData.samlConfig = {};
        } else if (formData.sso_type === IAuthType.DISABLE) {
      updatedFormData.ldapConfig = {};
      updatedFormData.samlConfig = {};
      updatedFormData.customJwtConfig = {};

    }

    // Now submit the updatedFormData

    const payload = {
      app_id: appId,
      api_key: api_key,
      args: JSON.stringify({
        app_id: appId,
        ...updatedFormData,
      }),
    };
    saveSiteSetting(payload);
  };

  const handleImageUpload = async (value: any) => {
    try {
        const { valid, message } = await validateImageDimensions(
          "brandLogo",
          value.file
      );
      if (valid) {
      const formData = new FormData();
      formData.append("image", value.file);
      formData.append("image_id", value.file.name);
      formData.append("appid", appId);
      formData.append("customLogo", "true");

      const authToken=await dispatch(getToken()).unwrap()  
      const res = await centralApi(
        "POST",
        API_ENDPOINTS.SAVE_CAMPAIGN_IMAGES,
        formData,
        null,
        false,
        authToken
      );     
      setFormData((prevData: any) => ({
        ...prevData,
        logo_image_url: res.baseURL + res.url,
        logo_image_name: value.file.name,
      }));
      dispatch(setSiteSetting({ logoUrl:  res.baseURL + res.url}));
       showSuccess(t("sucessfullySavedLabel"));

      dispatch(getToken())
    } else {
      showError(message);
    }
    } catch (error) {
      showError(t("invalidLabel"));
    }
  };
  //calling fetures setting
  useEffect(() => {
    if (activeApp.appId && loginUser.api_key) {
      dispatch(
        getFeaturesSettings({
          api_key: loginUser.api_key,
          app_id: activeApp?.appId,
        })
      );
    }
  }, [activeApp, loginUser]);
  async function saveSiteSetting(formData: any) {
    try {
      const authToken=await dispatch(getToken()).unwrap()  
      await centralApi("POST", API_ENDPOINTS.SAVE_SITE_SETTING, {...formData,authToken}, null);
      showSuccess(t("sucessfullySavedLabel"));

    } catch (error) {
      showError(t("somethingWrongLabel"));

    }

  }

 
  const handleSsoType = (value: string) => {
    setFormData((prevData: any) => ({
      ...prevData,
      sso_type: value,
    }));
  };
  const handleFileChange = async (formData: any) => {
    try {
      const authToken = await dispatch(getToken()).unwrap();  
      const file = formData.csv;
      const fd = new FormData();
      fd.append("app_id", appId);
      fd.append("file_name", file.name);
      fd.append("sso_cert", file);  
  
      await centralApi("POST", API_ENDPOINTS.UPLOAD_CUSTOM_SSO_CERTIFICATE, fd, null, false, authToken);
    setFormData((prevData: any) => ({
      ...prevData,
      customJwtConfig: {
        ...prevData.customJwtConfig,
        publicKey: file.name,
      },
    }));
  
    } catch (err) {
      showError(t("somethingWrongLabel"));
    }
  };
  
  
  return (
    <div className="site-setting-container">
      <div className="mt-4 mb-4  ">
        <h6 className="site-setting-container-heading">
          {t("siteSettingLabel")}
        </h6>
        <Divider className="site-setting-custom-divider" />

        <div>
          <div className=" col-sm-8 mt-4 align-items-center site-setting-form ">
            
            {formData == DataTypeEnum.UNDEFINED ? (
              <Spinner />
            ) : (
              <Form form={form} layout="horizontal" onFinish={onFormSubmit}>
                <Form.Item label={t("singleSignOnSSOLabel")}>
                  <Selector
                    onChange={(value) => {
                      setFormData((prevData: any) => ({
                        ...prevData,
                        is_sso: value,
                      }));
                    }}
                    value={formData?.is_sso}
                    size="middle"
                    defaultValue={AuthStatus.ENABLE}
                    options={[
                      {
                        value: AuthStatus.DISABLE,

                        label: t("disableLabel"),
                      },
                      {
                        value: AuthStatus.ENABLE,
                        label: t("enableLabel"),
                      },
                    ]}
                  />
                </Form.Item>
                <Form.Item label={t("ssoProviderLabel")}>
                  <Selector
                    onChange={(value) => {
                      handleSsoType(value);
                    }}
                    size="middle"
                    value={formData?.sso_type}
                    options={[
                      {
                        value: IAuthType.DISABLE,
                        label: t("noneLabel"),
                      },
                      {
                        value: IAuthType.AD,
                        label: t("activeDirectoryLabel"),
                      },
                      {
                        value: IAuthType.SAML,
                        label: t("samlBasedSSOLabel"),
                      },
                      {
                        value: IAuthType.CUSTOMJWT,
                        label: t("customJwtLabel"),
                      },
                    ]}
                  />
                </Form.Item>
                <Form.Item
                  label={t("customLogoLabel")}
                  
                >
                  <TextInput
                    disabled={true}
                    value={t("uploadImagesizeLabel")}
                    addonAfter={
                      <div>
                        <Upload
                          showUploadList={false}
                          multiple={false}
                          onChange={(value: any) => handleImageUpload(value)}
                          beforeUpload={() => false}
                          className="site-setting-form-add-button"
                        >
                          <PrimaryButton type="primary">
                            {t("uploadSimpleLabel")}
                          </PrimaryButton>
                        </Upload>
                      </div>
                    }
                  />
                </Form.Item>
                <Form.Item label={t("portalNameLabel")}>
                  <TextInput
                    value={formData?.portal_name}
                    onChange={(e: any) => {
                      setFormData((prevData: any) => ({
                        ...prevData,
                        portal_name: e.target.value,
                      }));
                    }}
                  />
                </Form.Item>

                {formData?.sso_type == IAuthType.AD ? (
                  <>
                    <Form.Item label={t("ldapUrlLabel")}>
                      <TextInput
                        value={formData?.ldapConfig?.url}
                        onChange={(e: any) => {
                          setFormData((prevData: any) => ({
                            ...prevData,
                            ldapConfig: {
                              ...prevData.ldapConfig,
                              url: e.target.value,
                            },
                          }));
                        }}
                      />
                    </Form.Item>
                    <Form.Item label={t("bindDnLabel")}>
                      <TextInput
                        value={formData?.ldapConfig?.bindDN}
                        onChange={(e: any) => {
                          setFormData((prevData: any) => ({
                            ...prevData,
                            ldapConfig: {
                              ...prevData.ldapConfig,
                              bindDN: e.target.value,
                            },
                          }));
                        }}
                      />
                    </Form.Item>
                    <Form.Item label={t("bindCredentialLabel")}>
                      <TextInput
                       type="password"
                       visibilityToggle={false}
                        value={formData?.ldapConfig?.bindCredentials}
                        onChange={(e: any) => {
                          setFormData((prevData: any) => ({
                            ...prevData,
                            ldapConfig: {
                              ...prevData.ldapConfig,
                              bindCredentials: e.target.value,
                            },
                          }));
                        }}
                      />
                    </Form.Item>
                    <Form.Item label={t("searchBaseLabel")}>
                      <TextInput
                        value={formData?.ldapConfig?.searchBase}
                        onChange={(e: any) => {
                          setFormData((prevData: any) => ({
                            ...prevData,
                            ldapConfig: {
                              ...prevData.ldapConfig,
                              searchBase: e.target.value,
                            },
                          }));
                        }}
                      />
                    </Form.Item>
                  </>
                ) : null}
                {formData?.sso_type == IAuthType.SAML && (
                  <>
                    <Form.Item
                      rules={[
                        {
                          required: true,

                        },
                      ]}
                      label={t("callBackUrlLabel")}
                    >
                      <TextInput
                        value={formData?.samlConfig?.saml_callbackURL}
                        onChange={(e: any) => {
                          setFormData((prevData: any) => ({
                            ...prevData,
                            samlConfig: {
                              ...prevData.samlConfig,
                              saml_callbackURL: e.target.value,
                            },
                          }));
                        }}
                      />
                    </Form.Item>
                    <Form.Item label={t("entryPointLabel")}>
                      <TextInput
                        value={formData?.samlConfig?.saml_entryPoint}
                        maxLength={500}
                        onChange={(e: any) => {
                          setFormData((prevData: any) => ({
                            ...prevData,
                            samlConfig: {
                              ...prevData.samlConfig,
                              saml_entryPoint: e.target.value,
                            },
                          }));
                        }}
                      />
                    </Form.Item>
                    <Form.Item label={t("issuerLabel")}>
                      <TextInput
                        value={formData?.samlConfig?.saml_issuer}
                        onChange={(e: any) => {
                          setFormData((prevData: any) => ({
                            ...prevData,
                            samlConfig: {
                              ...prevData.samlConfig,
                              saml_issuer: e.target.value,
                            },
                          }));
                        }}
                      />
                    </Form.Item>
                    <Form.Item label={t("certLabel")}>
                      <TextInput
                        value={formData?.samlConfig?.saml_cert}
                        maxLength={1500}
                        onChange={(e: any) => {
                          setFormData((prevData: any) => ({
                            ...prevData,
                            samlConfig: {
                              ...prevData.samlConfig,
                              saml_cert: e.target.value,
                            },
                          }));
                        }}
                      />
                    </Form.Item>

                    <Form.Item
                      label={t("xmlFileLabel")}
                      className="auth-key-item" // Add this className
                    >
                      <TextInput
                        disabled={true}
                        value={formData?.xml_fileName}
                        addonAfter={
                          <div>
                            <Upload
                              showUploadList={false}
                              multiple={false}
                              beforeUpload={() => false}
                            >
                              <PrimaryButton type="primary">
                                {t("uploadSimpleLabel")}
                              </PrimaryButton>
                            </Upload>{" "}
                          </div>
                        }
                      />
                    </Form.Item>
                  </>
                )}
       {formData?.sso_type == IAuthType.CUSTOMJWT && (
                  <>
    <Form.Item label={t("publickKeyLabel")} className="auth-key-item">
  <TextInput
    disabled={true}
    value={formData?.customJwtConfig?.publicKey || ""}
    addonAfter={
      <div>
        <Upload
          showUploadList={false}
          multiple={false}
          beforeUpload={() => false}
          onChange={(value) => handleFileChange({ csv: value.file })}
        >
          <PrimaryButton type="primary">{t("uploadLabel")}</PrimaryButton>
        </Upload>
      </div>
    }
  />
</Form.Item>

                  </>
                )}
                <Form.Item label={t("captchaNameLabel")}>
                  <Selector
                    onChange={(value) => {
                      setFormData((prevData: any) => ({
                        ...prevData,
                        captcha: value,
                      }));
                    }}
                    value={formData?.captcha}
                    size="middle"
                    options={[
                      {
                        value: AuthStatus.DISABLE,

                        label: t("disableLabel"),
                      },
                      {
                        value: AuthStatus.ENABLE,
                        label: t("enableLabel"),
                      },
                    ]}
                  />
              
                </Form.Item>
                <Form.Item label={t("useEmailChannelLabel")}>
                  <Selector
                    onChange={(value) => {
                      setFormData((prevData: any) => ({
                        ...prevData,
                        useEmailChannel: value,
                      }));
                    }}
                    value={formData?.useEmailChannel}
                    size="middle"
                    options={[
                      {
                        value: BooleanStringEnum.TRUE,
                        label: t("trueLabel"),
                      },
                      {
                        value: BooleanStringEnum.FALSE,
                        label: t("falseLabel"),
                      },
                    ]}
                  />
              
                </Form.Item>
                <Form.Item label={t("otpExpiryLabelInMin")}>
                <TextInput
                        value={formData?.otpExpiry}
                        type="number"         
                                 onChange={(e: any) => {
                          setFormData((prevData: any) => ({
                            ...prevData,
                            otpExpiry:e.target.value
                          }));
                        }}
                      />
                  
              
                </Form.Item>
                <Form.Item label={t("passwordExpiryLabel")}>
                <TextInput
                        value={formData?.passwordMaxAge}
                        min={0}
                        type="number"         
                        onChange={(e: any) => {
                        const passwordMaxAge = Number(e.target.value);
                        const value = isNaN(passwordMaxAge) ? 0 : passwordMaxAge;
                        setFormData((prevData: any) => ({
                            ...prevData,
                            passwordMaxAge:value
                          }));
                        }}
                      />   
                </Form.Item>
                <Form.Item label={t("loginTimeExpiryInMinLabel")}>
                <TextInput
                        value={formData?.loginTimeExpiry}
                        type="number"         
                                 onChange={(e: any) => {
                          setFormData((prevData: any) => ({
                            ...prevData,
                            loginTimeExpiry:e.target.value
                          }));
                        }}
                      />
                  
              
                </Form.Item>
                <Form.Item label={t("passwordRetryLimitLabel")}>
                <TextInput
                        value={formData?.passwordRetryLimit}
                        type="number"         
                                 onChange={(e: any) => {
                          setFormData((prevData: any) => ({
                            ...prevData,
                            passwordRetryLimit:e.target.value
                          }));
                        }}
                      />
                  
              
                </Form.Item>
           
                <Form.Item label={t("allowResetPasswordLabel")}>
                  <Selector
                    onChange={(value) => {
                      setFormData((prevData: any) => ({
                        ...prevData,
                        allowResetPassword: value,
                      }));
                    }}
                    value={formData?.allowResetPassword}
                    size="middle"
                    options={[
                      {
                        value: BooleanStringEnum.TRUE,
                        label: t("trueLabel"),
                      },
                      {
                        value: BooleanStringEnum.FALSE,
                        label: t("falseLabel"),
                      },
                    ]}
                  />
              
                </Form.Item>
                <Form.Item label={t("companyNamesLabel")}>
                  <TextInput
                    value={formData?.companyName}
                    onChange={(e: any) => {
                      setFormData((prevData: any) => ({
                        ...prevData,
                        companyName: e.target.value,
                      }));
                    }}
                  />
                </Form.Item>
                <Form.Item label={t("privacyLinkLabel")}>
                  <TextInput
                    value={formData?.privacyPolicyLink}
                    onChange={(e: any) => {
                      setFormData((prevData: any) => ({
                        ...prevData,
                        privacyPolicyLink: e.target.value,
                      }));
                    }}
                  />
                </Form.Item>
                <div className="">
                  <PrimaryButton
                    size="middle"
                    type="primary"
                    htmlType="submit"
                  >
                    {t("saveLabel")}
                  </PrimaryButton>
                </div>
              </Form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default SiteSettings;
